import { generate } from '@/utils/request';

const config = {
  prefix: '/sord/v1/{organizationId}',
  items: [{ key: 'getPriceType', url: '/item-prices/price-type', method: 'GET' }],
};

export default {
  ...generate(config),
};
